import axios from "./api";
class TestSubmissionService {
  getAll() {
    return axios.get(`/testSubmissions`);
  }
  get(id) {
    return axios.get(`/testSubmissions/${id}`);
  }
  create(data) {
    return axios.post(`/testSubmissions`, data);
  }
  update(id, data) {
    return axios.put(`/testSubmissions/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/testSubmissions/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new TestSubmissionService();
